// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5e0a8c9c","977":"8bc1bdfa"}[chunkId] + ".chunk.js";
};